import React, { type PropsWithChildren } from 'react';
import { StyleSheet, type StyleProp, type ViewStyle } from 'react-native';

import { radii } from '../../../core/theme/tokens';
import { GlassSurface } from '../glass';

type TabBarGlassBackgroundProps = PropsWithChildren<{
  style?: StyleProp<ViewStyle>;
  floating?: boolean;
}>;

/** Web tab bar — stronger blur + floating pill (matches iOS glass tab bar). */
export function TabBarGlassBackground({
  children,
  style,
  floating = true,
}: TabBarGlassBackgroundProps) {
  return (
    <GlassSurface
      tint="tabBar"
      rounded={floating ? 'none' : 'none'}
      showHairline
      style={[styles.shell, floating && styles.floating, style]}
    >
      {children}
    </GlassSurface>
  );
}

const styles = StyleSheet.create({
  shell: {
    width: '100%',
    backdropFilter: 'blur(28px) saturate(180%)',
    WebkitBackdropFilter: 'blur(28px) saturate(180%)',
    boxShadow: '0 10px 40px rgba(0, 0, 0, 0.45), inset 0 1px 0 rgba(255, 255, 255, 0.08)',
  } as object,
  floating: {
    borderRadius: radii.xl + 4,
  },
});
